module.exports = __webpack_public_path__ + "img/leiterinnen_irene-yildiz.e4cba425.png";